<template>
  <div class="content">
    <!-- 顶部横幅 -->
    <div class="banner-section">
      <img src="../assets/img/kjcgzh/Container.png" alt="" class="banner-image">
      <div class="banner-overlay">
        <div class="banner-text-wrapper">
<!--          <p class="banner-subtitle">TRADING RULES</p>-->
          <h1 class="banner-title">媒体中心</h1>
        </div>
      </div>
    </div>

    <!-- 媒体中心区域 -->
    <div class="media-section">
      <!-- 特色新闻轮播 -->
      <div v-if="featuredNews.length > 0" class="featured-carousel-wrapper">
        <el-carousel 
          :interval="5000" 
          arrow="always" 
          height="300px"
          indicator-position="outside"
        >
          <el-carousel-item v-for="(item, index) in featuredNews" :key="index">
            <div class="featured-news" @click="handleRowClick(item)">
              <div class="featured-image">
                <img v-if="item.coverImage" :src="item.coverImage" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">
                <img v-else src="../assets/img/q1.png" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">
<!--                <div class="featured-badge">LATEST NEWS</div>-->
              </div>
              <div class="featured-content">
                <div class="featured-header">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <rect x="2" y="3" width="12" height="11" rx="1" stroke="#9CA3AF" stroke-width="1.2"/>
                    <path d="M4 1V3M12 1V3M2 6H14" stroke="#9CA3AF" stroke-width="1.2" stroke-linecap="round"/>
                  </svg>
                  <span class="featured-date">{{ item.publishTime ? item.publishTime.slice(0, 10) : '' }}</span>
                  <span class="featured-divider">|</span>
                  <span class="featured-source">{{ item.publishUnit }}</span>
                </div>
                <h3 class="featured-title">{{ item.title }}</h3>
                <div class="featured-divider-line"></div>
                <p class="featured-excerpt">{{ stripHtml(item.content) || '' }}</p>
                <div class="featured-footer">
                  <span class="featured-read-more">
                    阅读全文
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 白色内容盒子 -->
      <div class="content-wrapper">
        <div v-loading="loading" element-loading-text="拼命加载中" class="news-container">
          <!-- 暂无数据 -->
          <div v-if="tableData.length === 0" class="no-data">暂无数据</div>

          <!-- 新闻列表 -->
          <div class="news-grid" v-if="regularNews.length > 0">
            <div 
              v-for="(item, index) in regularNews" 
              :key="index" 
              class="news-card"
              @click="handleRowClick(item)"
            >
              <div class="card-image">
                <img v-if="item.coverImage" :src="item.coverImage" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">
                <img v-else src="../assets/img/q1.png" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">
              </div>
              <div class="card-content">
                <div class="card-header">
                  <span class="card-source">{{ item.publishUnit }}</span>
                  <span class="card-date">{{ item.publishTime ? item.publishTime.slice(0, 10) : '' }}</span>
                </div>
                <h4 class="card-title">{{ item.title }}</h4>
                <p class="card-excerpt">{{ stripHtml(item.content) || '' }}</p>
                <div class="card-footer">
                  <span class="card-link">
                    查看详情
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrapper" v-if="listnum > 0">
          <div class="pagination-info">共 {{ listnum }} 条数据</div>
          <el-pagination
            class="custom-pagination"
            :page-size="8"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next"
            :total="listnum"
          />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  
  import { getAction } from '@/api/requests'
  
  
  export default {
    name: 'mtzxContent',
    components: {
  
     
    },
    data(){
      return{
        loading:false,
        listnum:0,
        currentPage: 1,
        featuredNews: [],  // 轮播固定3条，只请求一次
        tableData:[
        //   {
        //   name:'在推进创新驱动发展中闯出新路子',
        //   img:'',
        //   url:'https://www.stdaily.com/web/gdxw/2025-08/05/content_380575.html',
        //   fbdw:'中国科技网',
        //   time:'2025/8/5'
        // },{
        //   name:'加快推进科技服务业高质量发展',
        //   img:'',
        //   url:'https://www.news.cn/tech/20250630/010c03d446be488c987dfb66b8b1544b/c.html',
        //   fbdw:'科技日报',
        //   time:'2025/8/5'
        // },{
        //   name:'中国（上海）国际技术进出口交易会开幕',
        //   img:'',
        //   url:'http://pic.people.com.cn/n1/2025/0612/c1016-40499189.html',
        //   fbdw:'新华社',
        //   time:'2025/6/12'
        // },{
        //   name:'硬核服务”培育更多硬科技企业',
        //   img:'',
        //   url:'https://www.news.cn/20250608/6c3df839ed9546b6a54a62248670ee96/c.html',
        //   fbdw:'人民日报',
        //   time:'2025/6/8'
        // },{
        //   name:'构建未来产业投入增长机制 加快培育新质生产力',
        //   img:'',
        //   url:'https://www.ndrc.gov.cn/wsdwhfz/202505/t20250521_1397848.html',
        //   fbdw:'国家信息中心',
        //   time:'2025/5/21'
        // },{
        //   name:'九部门发文加快推进科技服务业高质量发展',
        //   img:'',
        //   url:'https://www.news.cn/20250519/aa41f55a2219440bbc8c437d4abe1d3b/c.html',
        //   fbdw:'新华网',
        //   time:'2025/5/19'
        // },{
        //   name:'前四月，全国技术合同成交额一点六万亿元——加快培育全国一体化技术市场',
        //   img:'',
        //   url:'http://gs.people.com.cn/n2/2025/0517/c183342-41230287.html',
        //   fbdw:'人民网',
        //   time:'2025/5/17'
        // },{
        //   name:'推进科技服务业高质量发展 如何发力',
        //   img:'',
        //   url:'https://www.news.cn/20250515/f1589ef66fac4bbc93d6bee7e1f51ce9/c.html',
        //   fbdw:'新华社',
        //   time:'2025/5/15'
        // },{
        //   name:'科技创新引领全面绿色转型',
        //   img:'',
        //   url:'https://www.news.cn/politics/20250508/8b02c6e8b6484be08d33c1691f470ee8/c.html',
        //   fbdw:'经济日报',
        //   time:'2025/5/8'
        // },{
        //   name:'政策助推创新链产业链两“链”相融',
        //   img:'',
        //   url:'https://www.news.cn/20250407/5bdf7341db454982bbeefb9ec4148082/c.html',
        //   fbdw:'经济参考报',
        //   time:'2025/4/7'
        // },{
        //   name:'河南省技术交易实现第一季度“开门红”',
        //   img:'',
        //   url:'http://henan.people.com.cn/n2/2025/0403/c351638-41184961.html',
        //   fbdw:'河南日报',
        //   time:'2025/4/3'
        // },{
        //   name:'中国技术交易所数字存证平台上线 服务新质生产力发展',
        //   img:'',
        //   url:'http://bj.people.com.cn/n2/2025/0330/c14540-41180588.html',
        //   fbdw:'人民网',
        //   time:'2025/3/30'
        // },{
        //   name:'中关村国际技术交易大会举办',
        //   img:'',
        //   url:'http://finance.people.com.cn/n1/2025/0328/c1004-40448970.html',
        //   fbdw:'广央网',
        //   time:'2025/3/28'
        // },{
        //   name:'促成技术交易 “科技红娘”如何做科学家合伙人',
        //   img:'',
        //   url:'http://sh.people.com.cn/n2/2025/0319/c176739-41169198.html',
        //   fbdw:'人民网',
        //   time:'2025/3/19'
        // },{
        //   name:'科创经纪人，为技术和市场牵线搭桥',
        //   img:'',
        //   url:'http://cq.people.com.cn/n2/2025/0213/c365425-41134616.html',
        //   fbdw:'人民日报',
        //   time:'2025/2/13'
        // },{
        //   name:'经济社会数字化转型是必答题 构建数据产权制度仍需探索实践',
        //   img:'',
        //   url:'https://www.ndrc.gov.cn/wsdwhfz/202409/t20240911_1392937.html',
        //   fbdw:'国家信息中心',
        //   time:'2024/9/11'
        // },{
        //   name:'抢占科技竞争和未来发展制高点——习近平总书记在全国科技大会、国家科学技术奖励大会、两院院士大会上重要讲话引发热烈反响',
        //   img:'',
        //   url:'http://www.moe.gov.cn/jyb_xwfb/s5147/202406/t20240626_1137885.html',
        //   fbdw:'人民日报',
        //   time:'2024/6/24'
        // },{
        //   name:'解读《河南省技术转移体系建设实施方案》：政策发力补齐我省技术转移“短板”',
        //   img:'',
        //   url:'https://kjt.henan.gov.cn/2019/04-17/1525795.html',
        //   fbdw:'河南省科学技术厅',
        //   time:'2024/1/19'
        // },{
        //   name:'切实推进技术市场工作高质量发展',
        //   img:'',
        //   url:'https://kjt.henan.gov.cn/2020/02-28/1525777.html',
        //   fbdw:'河南省科学技术厅',
        //   time:'2024/1/19'
        // },{
        //   name:'中原农谷种业技术交易服务平台建设启动',
        //   img:'',
        //   url:'http://henan.people.com.cn/n2/2023/1113/c351638-40637876.html',
        //   fbdw:'河南日报',
        //   time:'2023/11/13'
        // }
      ],
        tablists:[],
        tabis:'媒体中心',
        listdata:[]
      }
    },

    computed: {
      // 网格直接用全部分页数据
      regularNews() {
        return this.tableData
      }
    },

    created () {
      this.loadFeatured()
      this.yeshu()
    },
    methods:{
      // 单独请求轮播固定3条，只在初始化时调用一次
      loadFeatured() {
        getAction("/cms/news/list", { pageNum: 1, pageSize: 3, type: 2, status: 1 }).then(res => {
          this.featuredNews = (res.rows || []).map(item => ({
            ...item,
            coverImage: item.coverImage ? '/prod-api' + item.coverImage : ''
          }))
        })
      },
      handleRowClick(row){
        this.$router.push({
          path: '/mtzx-detail',
          query: {
            id: row.id,
          }
        })
      },
      stripHtml(str) {
        if (!str) return ' '
        return new DOMParser()
          .parseFromString(str, 'text/html')
          .body.textContent || ' ';
      },
      handlecurrweipai(e){
  console.log(e);
},
// 表颜色
tableRowClassName({rowIndex}) {

  console.log(rowIndex);
        if (rowIndex%2 ==0) {
          return 'warning-row';
        } else  {
          return 'success-row';
        }
        // return '';
      },
      yeshu (val=1) {
        console.log(val);
        this.loading = true
        let data = {
          pageNum: val,
          pageSize: 8,
          type: 2,
          status: 1
        }
        getAction("/cms/news/list", data).then(res => {
          this.listnum = res.total
          this.tableData = (res.rows || []).map(item => ({
            ...item,
            coverImage: item.coverImage ? '/prod-api' + item.coverImage : ''
          }))
          this.loading = false
          console.log(res)
        })
      },

      handleSizeChange (val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this.yeshu(val)
        console.log(`当前页: ${val}`);
      },
      tabchange(item){
this.tabis = item
      }
    }
  }
  </script>
  
  <style scoped>
.content {
  width: 100%;
  min-height: calc(100vh - 196px);
  background: #F5F7FA;
  position: relative;
}

/* 顶部横幅 */
.banner-section {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(10, 14, 26, 0.3) 0%, rgba(10, 14, 26, 0.6) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-text-wrapper {
  text-align: center;
}

.banner-subtitle {
  font-size: 14px;
  font-weight: 400;
  color: #51A2FF;
  letter-spacing: 2px;
  margin: 0 0 8px 0;
}

.banner-title {
  font-size: 36px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
}

/* 媒体中心区域 */
.media-section {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -66px;
  z-index: 10;
  padding-bottom: 60px;
}

/* 白色内容盒子 */
.content-wrapper {
  width: 1200px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.news-container {
  min-height: 400px;
}

.no-data {
  text-align: center;
  padding: 100px 0;
  font-size: 16px;
  color: #9CA3AF;
}

/* 特色新闻轮播容器 */
.featured-carousel-wrapper {
  width: 1280px;
  margin-bottom: 40px;
}

:deep(.el-carousel) {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

:deep(.el-carousel__container) {
  height: 300px;
}

:deep(.el-carousel__arrow) {
  background-color: rgba(255, 255, 255, 0.9);
  color: #3B82F6;
  width: 48px;
  height: 48px;
  font-size: 20px;
  border-radius: 50%;
  transition: all 0.3s;
}

:deep(.el-carousel__arrow:hover) {
  background-color: #3B82F6;
  color: #FFFFFF;
  transform: scale(1.1);
}

:deep(.el-carousel__arrow--left) {
  left: 20px;
}

:deep(.el-carousel__arrow--right) {
  right: 20px;
}

:deep(.el-carousel__indicators) {
  margin-top: 16px;
}

:deep(.el-carousel__indicator) {
  padding: 8px 4px;
}

:deep(.el-carousel__button) {
  width: 32px;
  height: 4px;
  border-radius: 2px;
  background-color: #D1D5DB;
  opacity: 1;
  transition: all 0.3s;
}

:deep(.el-carousel__indicator.is-active .el-carousel__button) {
  background-color: #3B82F6;
  width: 48px;
}

:deep(.el-carousel__indicator:hover .el-carousel__button) {
  background-color: #93C5FD;
}

/* 特色新闻样式 */
.featured-news {
  width: 100%;
  height: 300px;
  display: flex;
  gap: 0;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
  margin-bottom: 0;
  cursor: pointer;
  transition: all 0.3s;
  overflow: hidden;
}

.featured-news:hover {
  transform: scale(1.02);
}

.featured-image {
  flex-shrink: 0;
  width: 770px;
  height: 300px;
  background: #000;
  overflow: hidden;
  position: relative;
  transition: all 0.3s;
}

.featured-news:hover .featured-image img {
  transform: scale(1.05);
}

.featured-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s;
}

.placeholder-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%);
}

.featured-badge {
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 6px 16px;
  background: #3B82F6;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  border-radius: 20px;
}

.featured-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 40px;
  background: #FFFFFF;
  transition: all 0.3s;
}

.featured-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #9CA3AF;
}

.featured-date {
  color: #6B7280;
}

.featured-divider {
  color: #D1D5DB;
}

.featured-source {
  color: #3B82F6;
  font-weight: 500;
}

.featured-title {
  font-size: 22px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.featured-divider-line {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, #3B82F6 0%, rgba(59, 130, 246, 0) 100%);
  margin: 4px 0;
}

.featured-excerpt {
  font-size: 14px;
  line-height: 1.8;
  color: #6B7280;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.featured-footer {
  margin-top: auto;
}

.featured-read-more {
  color: #3B82F6;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.featured-read-more:hover {
  color: #2563EB;
  gap: 10px;
}

.featured-read-more svg {
  transition: transform 0.3s;
}

.featured-read-more:hover svg {
  transform: translateX(4px);
}

/* 新闻网格 */
.news-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.news-card {
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
}

.news-card:hover {
  border-color: #3B82F6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  transform: translateY(-4px);
}

.card-image {
  width: 100%;
  height: 160px;
  background: #F3F4F6;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.news-card:hover .card-image img {
  transform: scale(1.05);
}

.placeholder-image-small {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%);
}

.card-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #FFFFFF;
  flex: 1;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.card-source {
  width: 100px;
  height: 24px;
  background: #F1F5F9;
  border-radius: 4px;
  color: #62748E;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 8px;
}

.card-date {
  color: #9CA3AF;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 51px;
}

.card-excerpt {
  font-size: 13px;
  line-height: 1.6;
  color: #6B7280;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-footer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 12px;
  margin-top: auto;
  border-top: 1px solid #F3F4F6;
}

.card-link {
  color: #90A1B9;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s;
}

.card-link:hover {
  color: #2563EB;
  gap: 10px;
}

.card-link svg {
  transition: transform 0.3s;
}

.news-card:hover .card-link svg {
  transform: translateX(4px);
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #F3F4F6;
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #E5E7EB;
}

.pagination-info {
  font-size: 14px;
  color: #6B7280;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
  background-color: #3B82F6 !important;
  color: #FFFFFF !important;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:not(.disabled)) {
  background-color: #FFFFFF !important;
  color: #6B7280 !important;
  border: 1px solid #E5E7EB;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:hover) {
  color: #3B82F6 !important;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next),
:deep(.custom-pagination.el-pagination.is-background .btn-prev) {
  background-color: #FFFFFF;
  color: #6B7280;
  border: 1px solid #E5E7EB;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next:hover),
:deep(.custom-pagination.el-pagination.is-background .btn-prev:hover) {
  color: #3B82F6;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next:disabled),
:deep(.custom-pagination.el-pagination.is-background .btn-prev:disabled) {
  background-color: #F9FAFB;
  color: #D1D5DB;
  border-color: #E5E7EB;
}
  </style>
  
  